import { Translatable } from "@icc/shared/helpers";

/** Płytka zatrzaskowa nakładki */
export class RollerGuideOverlaySnapPlate {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    @Translatable({ model: 'WindowAccessories' })
    name?: string;
    img?: string;
    /** Profile nakładek powiązane z płytką */
    profiles?: number[];
    /** Typy produktów */
    shutterTypes?: number[];
    /** Kod do wydruków */
    printCode?: string;
    /** Waga */
    weight?: number;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
    /** Kolejność */
    order?: number;
    /** Dzielnik długości nakładki [mm] */
    snapPlateDivisor?: number | null;
    /** Korekta na długość nakładki [mm] */
    snapPlateLengthCorrection?: number | null;
    /** Wyliczona ilość płytek */
    quantity?: number;
}

export interface IccRollerGuideOverlaySnapPlate {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    name?: string;
    img?: string;
    /** Profile nakładek powiązane z płytką */
    profiles?: number[];
    /** Typy produktów */
    shutterTypes?: number[];
    /** Kod do wydruków */
    printCode?: string;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order?: number;
    /** Dzielnik długości nakładki [mm] */
    snapPlateDivisor?: number | null;
    /** Korekta na długość nakładki [mm] */
    snapPlateLengthCorrection?: number | null;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
